import { Bot, Globe } from "lucide-react";

import { Badge } from "~/components/ui/badge";
import { cn } from "~/lib/utils";

interface CotizacionSourceBadgeProps {
  source: string | null | undefined;
  className?: string;
}

// Shows where a cotización came from: the Nexor agent vs. the public website.
// Nexor rows get a violet accent so agent-created leads stand out; website stays
// neutral. Anything unrecognized falls back to the website presentation.
export const CotizacionSourceBadge = ({
  source,
  className,
}: CotizacionSourceBadgeProps) => {
  const isNexor = source === "nexor";
  const Icon = isNexor ? Bot : Globe;

  return (
    <Badge
      className={cn(
        isNexor
          ? "border-violet-200 bg-violet-100 text-violet-800 hover:bg-violet-100"
          : "border bg-muted text-muted-foreground hover:bg-muted",
        className
      )}
    >
      <Icon className="mr-1 h-3 w-3" />
      {isNexor ? "Nexor" : "Web"}
    </Badge>
  );
};
